import { usePartFeatures } from "#modules/part/view/usePartFeatures";
import { Features } from "#modules/quoteRequestLines/views/DetailsPanel/ProcessSteps/Features/Features";
import { QuoteRequestLinesSimilarPartDto } from "#modules/similarPart/infra/searchQuoteRequestLineSimilarParts.api";
import { Collapsable } from "#shared/view/designSystem/Collapsable";

export const ClusterCardFeatures = ({
  quoteRequestLine,
}: {
  quoteRequestLine: QuoteRequestLinesSimilarPartDto;
}) => {
  const { features } = usePartFeatures(quoteRequestLine.part.id);

  if (!features.length) {
    return null;
  }

  return (
    <Collapsable title="Formes détectées" fz={"sm"} textOn="" textOff="">
      <Features partId={quoteRequestLine.part.id} partType={quoteRequestLine.part.type ?? null} />
    </Collapsable>
  );
};
